var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"background"},[_c('div',{staticClass:"image"},[_c('div',{staticClass:"image-item",style:({ backgroundImage: _vm.mainImageSrc })})])])}
var staticRenderFns = []

export { render, staticRenderFns }